(function () {
	let swiperMulticolumn;
	let sectionResizeObserver;

	const hasMulticolumnSlider = () => Boolean(document.querySelector(".swiper--multicolumn"));

	const addClasses = () => {
		const slides = document.querySelectorAll(".swiper--multicolumn .multicolumn-list__item");
		slides.forEach((slide) => {
			slide.classList.add("swiper-slide");
		});
	};

	const initSlider = () => {
		if (!hasMulticolumnSlider()) return;
		swiperMulticolumn = new Swiper(".swiper--multicolumn", {
      loop: false,
      breakpoints: {
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
        },
        640: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 24,
        },
      },
      simulateTouch: true,
      allowTouchMove: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      mousewheel: {
        forceToAxis: true,
      },
      pagination: {
        el: ".multicolumn__pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".multicolumn__button-next",
        prevEl: ".multicolumn__button-prev",
      },
    });
	};

	const destroySlider = () => {
		const slides = document.querySelectorAll(".multicolumn-list__item");

		if (!swiperMulticolumn) {
			slides.forEach((slide) => {
				slide.removeAttribute("style");
				slide.classList.remove("swiper-slide");
			});
			return;
		}

		if (Array.isArray(swiperMulticolumn)) {
			swiperMulticolumn.forEach((swiper) => {
				swiper.destroy(true, true);
			});
		} else {
			if (!swiperMulticolumn.destroyed) {
				swiperMulticolumn.destroy(true, true);
			}
		}
		swiperMulticolumn = null;

		slides.forEach((slide) => {
			slide.removeAttribute("style");
			slide.classList.remove("swiper-slide");
		});
	};

	const syncMulticolumn = (width) => {
		const multicolumnSection = document.querySelector(".multicolumn-section");
		const currentWidth = width ?? multicolumnSection?.getBoundingClientRect().width ?? 0;

		if (currentWidth < 991 && hasMulticolumnSlider()) {
			addClasses();
			if (!swiperMulticolumn) {
				initSlider();
			}
		} else {
			destroySlider();
		}
	};

	const initMulticolumn = () => {
		const multicolumnSection = document.querySelector(".multicolumn-section");

		if (sectionResizeObserver) {
			sectionResizeObserver.disconnect();
		}

		syncMulticolumn();

		if (!multicolumnSection) return;

		sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;
			syncMulticolumn(entry.contentRect.width);
		});

		sectionResizeObserver.observe(multicolumnSection);
	};

	initMulticolumn();
	document.addEventListener("shopify:section:load", function () {
		initMulticolumn();
	});

	document.addEventListener("shopify:section:unload", function () {
		if (sectionResizeObserver) {
			sectionResizeObserver.disconnect();
			sectionResizeObserver = null;
		}
		destroySlider();
	});
})();
